import { render, staticRenderFns } from "./question-advertising.vue?vue&type=template&id=767ddea1&scoped=true&"
import script from "./question-advertising.vue?vue&type=script&lang=js&"
export * from "./question-advertising.vue?vue&type=script&lang=js&"
import style0 from "./question-advertising.vue?vue&type=style&index=0&id=767ddea1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ddea1",
  null
  
)

export default component.exports